__turbopack_context__.v({
  "interactive-legal-disclaimer": "EmailSignatureLegalDisclaimer-module-scss-module__le3SHq__interactive-legal-disclaimer",
});
